{
  "id": "venus",
  "name": "Venus",
  "kind": "simulator",
  "spotlight": true,
  "seoTitle": "Venus: RISC-V simulator for RV32IM assembly (UC Berkeley)",
  "seoDescription": "Venus is a teaching simulator for RV32IM RISC-V assembly from UC Berkeley, used in CS 61C. Write, assemble and step through RISC-V programs with registers and memory visible.",
  "url": "https://github.com/kvakil/venus",
  "homepage": "https://kvakil.github.io/venus/",
  "origin": "Keyhan Vakil, UC Berkeley",
  "authors": [
    "Keyhan Vakil"
  ],
  "started": 2017,
  "language": "Kotlin",
  "license": "MIT",
  "isa": "RV32IM",
  "archived": false,
  "capabilities": {
    "browser": true,
    "assembler": true,
    "stepBack": true,
    "registers": true,
    "memory": true,
    "callStack": false,
    "ecalls": true,
    "gpio": false,
    "breakpoints": true,
    "pipeline": false,
    "caches": false,
    "rv64": false
  },
  "sources": [
    {
      "label": "kvakil/venus README",
      "url": "https://github.com/kvakil/venus"
    },
    {
      "label": "CS 61C Lab 3, UC Berkeley",
      "url": "https://inst.eecs.berkeley.edu/~cs61c/sp22/labs/lab03/"
    },
    {
      "label": "Venus164 fork",
      "url": "https://github.com/chocopy/venus"
    }
  ],
  "blocks": [
    {
      "k": "h",
      "text": "Overview"
    },
    {
      "k": "p",
      "text": "Venus is a RISC-V simulator that runs in a web browser. A simulator is a program that imitates a processor, so you can run machine code without owning RISC-V hardware. Venus reads assembly code written for RV32IM. Assembly code is the readable text form of machine instructions. RV32I is the basic 32-bit RISC-V instruction set, and the M extension adds multiplication and division."
    },
    {
      "k": "p",
      "text": "The editor and the simulator share one page. Programs request services through ecall, the RISC-V instruction that asks the environment for something. Venus handles ecalls for printing values and for allocating more memory."
    },
    {
      "k": "h",
      "text": "History"
    },
    {
      "k": "p",
      "text": "Keyhan Vakil started Venus in 2017 at UC Berkeley. The project is written in Kotlin, a programming language that can be compiled to JavaScript. That compilation is what lets the simulator run inside a browser with nothing to install."
    },
    {
      "k": "p",
      "text": "UC Berkeley adopted Venus for CS 61C, its course on machine structures, where students write their first RISC-V programs. The course later kept its own fork at venus.cs61c.org. A fork is a copy of a project that is developed separately from the original. Another fork, Venus164, adds features for the ChocoPy compiler project in Berkeley's compilers course."
    },
    {
      "k": "h",
      "text": "Where it is used"
    },
    {
      "k": "p",
      "text": "Venus fits a first course in assembly. A student opens a page, pastes a program and runs it. Its instruction set stays at RV32IM, a small set that keeps the first lessons focused on registers, memory and control flow."
    }
  ]
}
